import { render, staticRenderFns } from "./MailNotifyDetail.vue?vue&type=template&id=7594d9e2&"
import script from "./MailNotifyDetail.vue?vue&type=script&lang=ts&"
export * from "./MailNotifyDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports